import { createAsyncThunk } from '@reduxjs/toolkit';
import dashboardApi from '~/apis/dashboard';
import { DASHBOARD_JOB_MOTHLY, DASHBOARD_PROJECT_OVERVIEW, DASHBOARD_PROJECT_REVENUE, DASHBOARD_TOP } from "~/utils/constants/actionType";


export const handleDashboardTop = createAsyncThunk<any, {}>(
  DASHBOARD_TOP,
  async ({}, { rejectWithValue }) => {
    try {
      const res = await dashboardApi.getTop();
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleDashboardProjectOverview = createAsyncThunk<any, {filter:any}>(
  DASHBOARD_PROJECT_OVERVIEW,
  async ({filter}, { rejectWithValue }) => {
    try {
      const res = await dashboardApi.getOverview(filter);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleDashboardJobMothly = createAsyncThunk<any, {filter:any}>(
  DASHBOARD_JOB_MOTHLY,
  async ({filter}, { rejectWithValue }) => {
    try {
      const res = await dashboardApi.getJobMonthly(filter);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleDashboardProjectRevenue = createAsyncThunk<any, {filter:any}>(
  DASHBOARD_PROJECT_REVENUE,
  async ({filter}, { rejectWithValue }) => {
    try {
      const res = await dashboardApi.getProjectRevenue({filter});
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);